import { render, staticRenderFns } from "./addMedicalOrder.vue?vue&type=template&id=cb3b2934&scoped=true&"
import script from "./addMedicalOrder.vue?vue&type=script&lang=js&"
export * from "./addMedicalOrder.vue?vue&type=script&lang=js&"
import style0 from "./addMedicalOrder.vue?vue&type=style&index=0&id=cb3b2934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3b2934",
  null
  
)

export default component.exports